import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import {
  getAboutAdmin, updateAbout,
  getMVAdmin, updateMission, updateVision,
  getMilestonesAdmin, addMilestone, updateMilestone, deleteMilestone,
  getFounderAdmin, updateFounder,
} from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

export default function AdminAboutContent() {
  const [about, setAbout] = useState('');
  const [mv, setMv] = useState({ mission: '', vision: '' });
  const [milestones, setMilestones] = useState([]);
  const [founder, setFounder] = useState({ Image: '', Name: '', Subheading: '', Paragraph: '' });
  const [newM, setNewM] = useState({ Number: '', Title: '' });
  const [editM, setEditM] = useState(null);
  const [saving, setSaving] = useState({});
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    getAboutAdmin().then(setAbout);
    getMVAdmin().then(setMv);
    getMilestonesAdmin().then(setMilestones);
    getFounderAdmin().then(setFounder);
  }, []);

  const save = (key, fn) => async (e) => {
    e?.preventDefault();
    setSaving(s => ({ ...s, [key]: true }));
    await fn();
    setSaving(s => ({ ...s, [key]: false }));
    alert('Saved!');
  };

  const handleFounderImg = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try { const url = await uploadToCloudinary(file); setFounder(f => ({ ...f, Image: url })); }
    catch { alert('Upload failed'); }
    finally { setUploading(false); }
  };

  const handleAddMilestone = async (e) => {
    e.preventDefault();
    if (!newM.Number || !newM.Title) return;
    await addMilestone({ ...newM, order: milestones.length });
    setNewM({ Number: '', Title: '' });
    getMilestonesAdmin().then(setMilestones);
  };

  const handleSaveMilestone = async (m) => {
    await updateMilestone(m.id, { Number: m.Number, Title: m.Title });
    setEditM(null);
    getMilestonesAdmin().then(setMilestones);
  };

  const handleDeleteMilestone = async (id) => {
    if (!window.confirm('Delete milestone?')) return;
    await deleteMilestone(id);
    setMilestones(p => p.filter(m => m.id !== id));
  };

  return (
    <AdminLayout title="About Content">
      {/* About Paragraph */}
      <div className="admin-section">
        <div className="admin-section-header"><h2>About Paragraph</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={save('about', () => updateAbout(about))} style={{ maxWidth: 700 }}>
            <div><textarea rows={6} value={about} onChange={e => setAbout(e.target.value)} /></div>
            <div><button className="a-btn a-btn-primary" type="submit" disabled={saving.about}>{saving.about ? 'Saving…' : 'Save'}</button></div>
          </form>
        </div>
      </div>

      {/* Mission & Vision */}
      <div className="admin-section">
        <div className="admin-section-header"><h2>Mission & Vision</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={save('mv', () => Promise.all([updateMission(mv.mission), updateVision(mv.vision)]))} style={{ maxWidth: 700 }}>
            <div><label>Mission</label><textarea rows={3} value={mv.mission} onChange={e => setMv(m => ({ ...m, mission: e.target.value }))} /></div>
            <div><label>Vision</label><textarea rows={3} value={mv.vision} onChange={e => setMv(m => ({ ...m, vision: e.target.value }))} /></div>
            <div><button className="a-btn a-btn-primary" type="submit" disabled={saving.mv}>{saving.mv ? 'Saving…' : 'Save'}</button></div>
          </form>
        </div>
      </div>

      {/* Milestones */}
      <div className="admin-section">
        <div className="admin-section-header"><h2>Milestones</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={handleAddMilestone} style={{ maxWidth: 460, marginBottom: 20 }}>
            <div className="admin-form-row">
              <div><label>Number / Stat</label><input value={newM.Number} onChange={e => setNewM(m => ({ ...m, Number: e.target.value }))} placeholder="e.g. 500+" required /></div>
              <div><label>Title</label><input value={newM.Title} onChange={e => setNewM(m => ({ ...m, Title: e.target.value }))} placeholder="e.g. Happy Brides" required /></div>
            </div>
            <div><button className="a-btn a-btn-accent" type="submit">+ Add Milestone</button></div>
          </form>
          {milestones.map(m => (
            <div key={m.id} className="admin-list-item">
              {editM === m.id ? (
                <>
                  <input defaultValue={m.Number} id={`mn-${m.id}`} style={{ width: 80 }} />
                  <input defaultValue={m.Title} id={`mt-${m.id}`} style={{ flex: 1 }} />
                  <button className="a-btn a-btn-sm a-btn-primary" onClick={() => handleSaveMilestone({ ...m, Number: document.getElementById(`mn-${m.id}`).value, Title: document.getElementById(`mt-${m.id}`).value })}>Save</button>
                  <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => setEditM(null)}>Cancel</button>
                </>
              ) : (
                <>
                  <div className="admin-list-item-content"><strong>{m.Number}</strong> — {m.Title}</div>
                  <div className="admin-list-item-actions">
                    <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => setEditM(m.id)}>Edit</button>
                    <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDeleteMilestone(m.id)}>Delete</button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Founder */}
      <div className="admin-section">
        <div className="admin-section-header"><h2>Founder Info</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={save('founder', () => updateFounder(founder))} style={{ maxWidth: 600 }}>
            <div><label>Photo</label>
              <label className="upload-box">
                <input type="file" accept="image/*" onChange={handleFounderImg} />
                {uploading ? <p>Uploading…</p> : founder.Image ? <img src={founder.Image} alt="" style={{ maxHeight: 100 }} /> : <p>Click to upload</p>}
              </label>
            </div>
            <div><label>Name</label><input value={founder.Name} onChange={e => setFounder(f => ({ ...f, Name: e.target.value }))} /></div>
            <div><label>Subheading</label><input value={founder.Subheading} onChange={e => setFounder(f => ({ ...f, Subheading: e.target.value }))} /></div>
            <div><label>Bio Paragraph</label><textarea rows={5} value={founder.Paragraph} onChange={e => setFounder(f => ({ ...f, Paragraph: e.target.value }))} /></div>
            <div><button className="a-btn a-btn-primary" type="submit" disabled={saving.founder}>{saving.founder ? 'Saving…' : 'Save'}</button></div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}
